module.exports = __webpack_public_path__ + "img/فارسی.85eb4247.png";